import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { CheckCircle, ListTask, PlusCircle } from "react-bootstrap-icons";

export default function Todo() {
  const [visibleCount, setVisibleCount] = useState(3);
  const [filter, setFilter] = useState("All");
  const [newTask, setNewTask] = useState("");

  const [tasks, setTasks] = useState([
    { id: 1, priority: "High", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: false },
    { id: 2, priority: "High", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: false },
    { id: 3, priority: "High", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: true },
    { id: 4, priority: "Medium", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: false },
    { id: 5, priority: "Medium", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: false },
    { id: 6, priority: "Low", title: "Finalize Project Proposal", date: "15 Jan 2026", completed: false }
  ]);

  const addTask = () => {
    if (!newTask.trim()) return;

    const newItem = {
      id: Date.now(),
      priority: "High",
      title: newTask,
      date: new Date().toDateString(),
      completed: false
    };

    setTasks([newItem, ...tasks]);
    setNewTask("");
  };

  const toggleComplete = (id) => {
    const updated = tasks.map((t) =>
      t.id === id ? { ...t, completed: !t.completed } : t
    );
    setTasks(updated);
  };

  const filteredTasks =
    filter === "All" ? tasks : tasks.filter((t) => t.priority === filter);

  const grouped = {
    High: filteredTasks.filter((t) => t.priority === "High"),
    Medium: filteredTasks.filter((t) => t.priority === "Medium"),
    Low: filteredTasks.filter((t) => t.priority === "Low")
  };

  const total = tasks.length;
  const completed = tasks.filter((t) => t.completed).length;
  const pending = total - completed;

  const renderTask = (task, index) => (
    <div
      key={task.id}
      className={`todo-item d-flex justify-content-between align-items-center bg-white shadow-sm rounded-3 p-2 mb-2 ${
        task.completed ? "opacity-50 text-decoration-line-through" : ""
      }`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {/* Left */}
      <div className="d-flex align-items-center gap-2">
        <input
          type="checkbox"
          checked={task.completed}
          onChange={() => toggleComplete(task.id)}
          className="form-check-input"
        />
        <CheckCircle className="text-success" size={16} />
        <span className="fw-semibold small">{task.title}</span>
        <span className="badge bg-light text-dark border small">
          {task.date}
        </span>
      </div>

      {/* Right */}
      <div className="d-flex align-items-center gap-2">
        <span className="badge bg-success-subtle text-success small">
          Project
        </span>
        <span className="badge bg-danger-subtle text-danger small">
          On Hold
        </span>

        <div className="d-flex">
          <img src="https://i.pravatar.cc/25?img=1" alt="todo" className="rounded-circle border" />
          <img src="https://i.pravatar.cc/25?img=2" alt="todo" className="rounded-circle border ms-n2" />
          <img src="https://i.pravatar.cc/25?img=3" alt="todo" className="rounded-circle border ms-n2" />
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-4 bg-light">

      {/* Heading */}
      <h5 className="fw-semibold mb-3 d-flex align-items-center gap-2">
        <ListTask /> Todo
      </h5>

      <div className="card border-0 shadow-sm p-3 todo-card">

        {/* Header */}
        <div className="d-flex justify-content-between mb-3">
          <h6 className="fw-bold mb-0">Total Todo</h6>
          <div className="small text-muted">
            Total: {total} | Pending: {pending} | Completed: {completed}
          </div>
        </div>

        {/* Add Task */}
        <div className="d-flex gap-2 mb-3">
          <input
            className="form-control"
            placeholder="Add new task..."
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
          />
          <button className="btn btn-outline-primary d-flex align-items-center gap-1" onClick={addTask}>
            <PlusCircle size={16}/> Add
          </button>
        </div>

        {/* Filters */}
        <div className="d-flex gap-2 mb-3">
          {["All", "High", "Medium", "Low"].map((p) => (
            <button
              key={p}
              className={`btn btn-sm ${
                filter === p ? "btn-primary" : "btn-light border"
              }`}
              onClick={() => setFilter(p)}
            >
              {p}
            </button>
          ))}
        </div>

        {/* Sections */}
        {["High", "Medium", "Low"].map((priority) => (
          <div key={priority} className="mb-3">
            <div className="fw-semibold small mb-2">{priority}</div>
            {grouped[priority]
              .slice(0, visibleCount)
              .map((task, i) => renderTask(task, i))}
          </div>
        ))}

        {/* Load More */}
        <div className="text-center mt-3">
          <button
            className="btn btn-dark rounded-pill px-4"
            onClick={() => setVisibleCount((prev) => prev + 2)}
          >
            Load More
          </button>
        </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        .todo-card {
          animation: fadeInUp 0.6s ease;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }


        .todo-item {
          opacity: 0;
          transform: translateY(15px);
          animation: slideUp 0.4s ease forwards;
        }

        @keyframes slideUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }


        .todo-item:hover {
          transform: translateY(-2px);
          transition: 0.2s ease;
        }

        .form-check-input {
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .form-check-input:checked {
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
}